module.exports = __webpack_public_path__ + "img/Kosala.5cb7cc31.jpg";